/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactType } from './ContactType';
import {
    ContactTypeFromJSON,
    ContactTypeFromJSONTyped,
    ContactTypeToJSON,
} from './ContactType';
import type { UserProfileDetails } from './UserProfileDetails';
import {
    UserProfileDetailsFromJSON,
    UserProfileDetailsFromJSONTyped,
    UserProfileDetailsToJSON,
} from './UserProfileDetails';

/**
 * A payload that will add a client contact to a client organization. One of actorRID or details should be present in the payload.
 * @export
 * @interface AddClientContact
 */
export interface AddClientContact {
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof AddClientContact
     */
    actorRID?: string;
    /**
     * 
     * @type {UserProfileDetails}
     * @memberof AddClientContact
     */
    details?: UserProfileDetails;
    /**
     * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
     * 
     * @type {string}
     * @memberof AddClientContact
     */
    metadataSchemaRID?: string;
    /**
     * 
     * @type {object}
     * @memberof AddClientContact
     */
    metadata?: object;
    /**
     * 
     * @type {ContactType}
     * @memberof AddClientContact
     */
    contactType?: ContactType;
}

/**
 * Check if a given object implements the AddClientContact interface.
 */
export function instanceOfAddClientContact(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddClientContactFromJSON(json: any): AddClientContact {
    return AddClientContactFromJSONTyped(json, false);
}

export function AddClientContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actorRID': !exists(json, 'actorRID') ? undefined : json['actorRID'],
        'details': !exists(json, 'details') ? undefined : UserProfileDetailsFromJSON(json['details']),
        'metadataSchemaRID': !exists(json, 'metadataSchemaRID') ? undefined : json['metadataSchemaRID'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'contactType': !exists(json, 'contactType') ? undefined : ContactTypeFromJSON(json['contactType']),
    };
}

export function AddClientContactToJSON(value?: AddClientContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actorRID': value.actorRID,
        'details': UserProfileDetailsToJSON(value.details),
        'metadataSchemaRID': value.metadataSchemaRID,
        'metadata': value.metadata,
        'contactType': ContactTypeToJSON(value.contactType),
    };
}

